import notes from '../shared/populate-datetime';

export default {
  loaded() {
    notes()
  }
}
